import { render, staticRenderFns } from "./FormPackingLocale.vue?vue&type=template&id=24c433e8&scoped=true&"
import script from "./FormPackingLocale.vue?vue&type=script&lang=js&"
export * from "./FormPackingLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c433e8",
  null
  
)

export default component.exports